import { createServerFn } from '@tanstack/react-start'
import type { ContactFormType } from '@/components/ContactForm.tsx'
import { api } from '@/lib/connectivity.ts'

export const saveContact = createServerFn({
	method: 'POST',
	response: 'data',
})
	.validator((data: ContactFormType) => data)
	.handler(async ({ data: contact }) => await api.post<any>('/contact', contact).then(({ data }) => data))
